import styled from 'styled-components';

export const ReviewsSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};
  margin-top: ${({ theme }) => theme.spacing(2)};

  width: 100%;
  max-width: 100.5rem;
`;

export const RatingBadge = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  color: ${({ theme }) => theme.palette.text.primary};
  text-align: center;
`;

export const ReviewGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.spacing(4)};

  width: 100%;

  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.sm)} {
    grid-template-columns: repeat(3, 1fr);
  }
`;
